import { Injectable } from "@angular/core";
import { environment } from "../../../environments/environment";
import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { Router } from "@angular/router";
import { throwError, Observable, catchError } from "rxjs";
import { User } from "../models/Userverify.model";
@Injectable({
  providedIn: "root",
})
export class ApiService {
  API_URL: String = environment.API_URL;
  avoidCompanyIdArray = [];
  public currentUser: User;
  constructor(private http: HttpClient, private router: Router) {}

  private setHeaders(): HttpHeaders {
    const headersConfig = {};
    if (localStorage.getItem("currentUser")) {
      this.currentUser = JSON.parse(
        localStorage.getItem("currentUser") || "{}"
      );
      if (!this.currentUser.guest_access_allowed)
        headersConfig["Authorization"] = "Bearer " + this.currentUser.token;
    }
    return new HttpHeaders(headersConfig);
  }

  private setFormDataHeaders(): HttpHeaders {
    const headersConfig = {};
    if (localStorage.getItem("currentUser")) {
      this.currentUser = JSON.parse(
        localStorage.getItem("currentUser") || "{}"
      );
      if (!this.currentUser.guest_access_allowed)
        headersConfig["Authorization"] = "Bearer " + this.currentUser.token;
    }
    return new HttpHeaders(headersConfig);
  }

  get(path: string, params: HttpParams = new HttpParams()): Observable<any> {
    return this.http
      .get(`${this.API_URL}${path}`, {
        headers: this.setHeaders(),
        params: params,
      })
      .pipe(
        catchError((error: any) => {
          if (error.status === 401) {
            if (error.error.error == "Unauthenticated.") {
              localStorage.removeItem("currentUser");
              this.router.navigateByUrl("/login");
            }
          } else if (error.status === 500) {
            alert(error?.error?.message);
          }
          return throwError(() => error);
        })
      );
  }

  getRawData(): Observable<any> {
    const api = "https://portal.payar.co.uk/cmspages/about_us_webapp";
    return this.http.get(api, { responseType: "text" });
  }
  put(path: string, body): Observable<any> {
    return this.http
      .put(`${this.API_URL}${path}`, body, { headers: this.setHeaders() })
      .pipe(
        catchError((error: any) => {
          if (error.status === 401) {
            if (error.error.error == "Unauthenticated.") {
              localStorage.removeItem("currentUser");
              this.router.navigateByUrl("/login");
            }
          }
          return throwError(error.json());
        })
      );
  }

  formDataPut(path: string, body): Observable<any> {
    return this.http
      .post(`${this.API_URL}${path}`, body, {
        headers: this.setFormDataHeaders(),
      })
      .pipe(
        catchError((error: any) => {
          if (error.status === 401) {
            if (error.error.error == "Unauthenticated.") {
              localStorage.removeItem("currentUser");
              this.router.navigateByUrl("/login");
            }
          }
          return throwError(() => error);
        })
      );
  }

  post(path: string, body): Observable<any> {
    return this.http
      .post(`${this.API_URL}${path}`, body, {
        headers: this.setFormDataHeaders(),
      })
      .pipe(
        catchError((error: any) => {
          return throwError(() => error);
        })
      );
  }
  authpost(path: string, body): Observable<any> {
    return this.http
      .post(`${this.API_URL}${path}`, body, {
        headers: this.setFormDataHeaders(),
      })
      .pipe(
        catchError((error: any) => {
          console.log(error);
          return throwError(() => error);
        })
      );
  }
  create(path: string, model: any) {
    return this.http.post(`${this.API_URL}${path}`, model).pipe(
      catchError((error: any) => {
        console.log(error);
        if (error.status === 401) {
          if (error.error.error == "Unauthenticated.") {
            localStorage.removeItem("currentUser");
            this.router.navigateByUrl("/login");
          }
        }
        return throwError(() => error);
      })
    );
  }
  formDataPost(path: string, body): Observable<any> {
    console.log("formDataPost called:", {
      path,
      bodyType: body.constructor.name,
      isFormData: body instanceof FormData,
    });

    if (body instanceof FormData) {
      console.log("FormData entries:");
      body.forEach((value, key) => {
        console.log(
          `  ${key}:`,
          value instanceof File
            ? {
                name: value.name,
                size: value.size,
                type: value.type,
              }
            : value,
        );
      });
    }

    return this.http
      .post(`${this.API_URL}${path}`, body, {
        headers: this.setFormDataHeaders(),
      })
      .pipe(
        catchError((error: any) => {
          console.error("formDataPost error:", error);
          if (error.status === 401) {
            if (error.error.error == "Unauthenticated.") {
              localStorage.removeItem("currentUser");
              this.router.navigateByUrl("/login");
            }
          }
          return throwError(() => error);
        }),
      );
  }

  patch(path: string, body): Observable<any> {
    return this.http
      .patch(`${this.API_URL}${path}`, body, { headers: this.setHeaders() })
      .pipe(
        catchError((error: any) => {
          if (error.status === 401) {
            if (error.error.error == "Unauthenticated.") {
              localStorage.removeItem("currentUser");
              this.router.navigateByUrl("/login");
            }
          }
          return throwError(() => error);
        })
      );
  }

  formDataPatch(path: string, body): Observable<any> {
    return this.http
      .patch(`${this.API_URL}${path}`, body, {
        headers: this.setFormDataHeaders(),
      })
      .pipe(
        catchError((error: any) => {
          if (error.status === 401) {
            if (error.error.error == "Unauthenticated.") {
              localStorage.removeItem("currentUser");
              this.router.navigateByUrl("/login");
            }
          }
          return throwError(() => error);
        })
      );
  }

  delete(path: string): Observable<any> {
    return this.http
      .delete(`${this.API_URL}${path}`, { headers: this.setHeaders() })
      .pipe(
        catchError((error: any) => {
          if (error.status === 401) {
            if (error.error.error == "Unauthenticated.") {
              localStorage.removeItem("currentUser");
              this.router.navigateByUrl("/login");
            }
          }
          return throwError(() => error);
        })
      );
  }

  getFile(
    path: string,
    params: HttpParams = new HttpParams()
  ): Observable<any> {
    return this.http
      .get(`${this.API_URL}${path}`, {
        headers: this.setHeaders(),
        params: params,
        responseType: "blob",
      })
      .pipe(
        catchError((error: any) => {
          if (error.status === 401) {
          }
          return throwError(() => error);
        })
      );
  }
}
